import { createAction, props } from '@ngrx/store';

export const setchangeDateInitVigEndosoAction = createAction(
  '[CHANGEDATEINITVIGENDOSO] Set changeDateInitVigEndoso',
  props<{ changeDateInitVigEndoso: boolean }>()
);
